/* ============================================================
   NOVA STUDIO – Shopify JavaScript v2
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- THUMBNAIL WECHSEL ----
  document.querySelectorAll('.ns-product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.ns-product-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ---- GRÖßENAUSWAHL ----
  window.nsSelectOption = function(btn) {
    var group = btn.closest('.ns-size-grid');
    if (group) group.querySelectorAll('.ns-size-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    nsUpdateVariant();
  };

  function nsUpdateVariant() {
    if (!window.nsProductVariants) return;
    var selectedOptions = [];
    document.querySelectorAll('.ns-option-group').forEach(function(group) {
      var active = group.querySelector('.ns-size-btn.active');
      if (active) selectedOptions.push(active.dataset.optionValue);
    });
    var variant = window.nsProductVariants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
    });
    if (variant) {
      var input = document.getElementById('variantId');
      if (input) input.value = variant.id;
      var addBtn = document.querySelector('.ns-add-to-cart-full');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      var stockInfo = document.querySelector('.ns-stock-info');
      if (stockInfo) {
        stockInfo.className = 'ns-stock-info ' + (variant.available ? 'ns-in-stock' : 'ns-out-of-stock');
        stockInfo.textContent = variant.available ? 'Auf Lager – Lieferzeit 10–14 Tage' : 'Diese Größe ist ausverkauft';
      }
    }
  }

  // ---- QUICK ADD ----
  window.nsQuickAdd = function(btn, variantId) {
    if (!variantId) return;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(res) { if (!res.ok) throw new Error('err'); return res.json(); })
    .then(function() {
      btn.textContent = 'Hinzugefügt!';
      nsShowToast();
      nsUpdateCartCount();
      setTimeout(function() { btn.textContent = 'Schnell hinzufügen'; btn.disabled = false; }, 2000);
    })
    .catch(function() { btn.textContent = 'Fehler – nochmal'; btn.disabled = false; });
  };

  // ---- TOAST ----
  window.nsShowToast = function() {
    var toast = document.getElementById('ns-toast');
    if (!toast) return;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2500);
  };

  // ---- WARENKORB ZÄHLER ----
  window.nsUpdateCartCount = function() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      }).catch(function() {});
  };

  // ---- PRODUKT FORM ----
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = document.getElementById('variantId');
      if (!variantInput || !variantInput.value) return;
      var addBtn = productForm.querySelector('.ns-add-to-cart-full');
      var originalText = addBtn.textContent;
      addBtn.textContent = '...';
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value), quantity: 1 })
      })
      .then(function(res) { if (!res.ok) throw new Error('err'); return res.json(); })
      .then(function() {
        addBtn.textContent = 'Hinzugefügt!';
        nsShowToast();
        nsUpdateCartCount();
        setTimeout(function() { addBtn.textContent = originalText; addBtn.disabled = false; }, 2000);
      })
      .catch(function() { addBtn.textContent = 'Fehler – nochmal'; addBtn.disabled = false; });
    });
  }

  // ---- BILD WECHSEL ----
  window.nsChangeImage = function(thumb, src) {
    var mainImg = document.getElementById('mainImg');
    if (mainImg) mainImg.src = src;
    document.querySelectorAll('.ns-product-thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  };

});
